import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_BASE } from 'config/api';

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getVisitorId() {
  let id = localStorage.getItem('visitor_id');
  if (!id) {
    id = uuid();
    localStorage.setItem('visitor_id', id);
  }
  return id;
}

function getSessionId() {
  let id = sessionStorage.getItem('session_id');
  if (!id) {
    id = uuid();
    sessionStorage.setItem('session_id', id);
  }
  return id;
}

export default function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + (location.search || '');
    if (path.startsWith('/admin')) return;

    const payload = {
      path,
      title: document.title || '',
      referrer: document.referrer || '',
      visitorId: getVisitorId(),
      sessionId: getSessionId()
    };

    try {
      fetch(`${API_BASE}/analytics/pageview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(() => {});
    } catch (e) {}
  }, [location]);
}
